import styled from "@emotion/styled";
import type { FC } from "react";
import OverlayPillWithSpinner from "../OverlayPillWithSpinner/OverlayPillWithSpinner";
import { cmsImageUrl } from "src/lib/cmsImageUrl";
import { APP_CONTENT_WIDTH_WITHOUT_PADDING } from "src/constants/layout";

type SpacerSize = "md" | "lg" | "xl";

const Content = styled.div`
  label: healthInformationExchangeStep_content;
  width: 100%;
  padding: 1.5rem 1.6rem;
  box-sizing: border-box;
`;

const ContentInner = styled.div`
  label: healthInformationExchangeStep_contentInner;
  width: 100%;
  max-width: ${APP_CONTENT_WIDTH_WITHOUT_PADDING}px;
  margin: 0 auto;
`;

/**
 * Vertical gap matching the design tokens the old <nine-spacer s="…"> used.
 * `$size` maps straight onto the global `--space-*` scale.
 */
const Spacer = styled.div<{ $size: SpacerSize }>`
  label: healthInformationExchangeStep_spacer;
  height: var(--space-${({ $size }) => $size});
`;

const Title = styled.div`
  label: healthInformationExchangeStep_title;
  display: flex;
  gap: 0.5rem;
  justify-content: start;
  align-items: center;
  margin-bottom: 0.25rem;

  svg {
    color: var(--color-gray, #aaa7a0);
  }
`;

const Header = styled.h2`
  label: healthInformationExchangeStep_header;
  font-weight: 600;
`;

const ImageBase: FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={className}>
      <OverlayPillWithSpinner
        msg={"healthInfoExchange.overlayPillMessage"}
        className={"overlay-pill-with-spinner-in-hie"}
      />
    </div>
  );
};

const ImageHeader = styled(ImageBase)`
  label: healthInformationExchangeStep_imageHeader;
  width: 100%;
  aspect-ratio: 1024/683;
  position: relative;
  background-image: url(${cmsImageUrl(
    "6425906a15c339bb079cfc4510be94c2a483dca3-1024x683.jpg"
  )});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  border-radius: 0.5rem;

  /*
   * Anchor the pill to the right edge and let it bleed past it: the image's
   * overflow: hidden clips the right rounded cap to a flat "cut" edge. The pill
   * hugs its content (width: max-content) so the text sits close to the cut
   * rather than leaving a wide empty gap; the left rounded end stays visible.
   */
  .overlay-pill-with-spinner-in-hie {
    position: absolute;
    left: auto;
    right: -1.5rem;
    bottom: 1.5rem;
    width: max-content;
    max-width: calc(100% + 1.5rem);
  }
`;

export const healthInformationExchangeStepStyled = {
  Title,
  Header,
  ImageHeader,
  Content,
  ContentInner,
  Spacer
};
